import React from "react";
import styled from "styled-components";
import ThirtyCard from "./ThirtyCard";

const PrimeGrid = styled("div")`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(1, 29.5vh);

    background: #9AA8B1;

    font-family: "Oswald", sans-serif;
    font-weight: 600;
    font-size: 18vh;    

    border: 2px solid black;
    line-height: 30vh;

    .P {
        grid-row: 1;
        grid-column: 4;
        border: inherit;
        background: #C6BCAB;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 1.5vh;
    }
    .R {
        grid-row: 1;
        grid-column: 2;
        border: inherit;
        background: #9F8B70;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 1.5vh;
    }
    .I {
        grid-row: 1;
        grid-column: 3;
        border: inherit;
        background: #9AA8B1;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 1.5vh;
    }
    .M {
        grid-row: 1;
        grid-column: 1;
        border: inherit;
        background: #868066;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 1.5vh;
    }

`;

const Container = styled.div`
    margin-left: auto;
background-color: #868066;
    position: relative;
    height: fit-content;
    width: 100%;
`;

const Grid = styled.div`
    display: grid;
    grid-gap: 4px; /* This sets the gap between the grid items */
    row-gap: 4px;
    grid-template-columns: repeat(2, 1fr);
    justify-items: center;
    align-items: center;
    flex-direction: column;
    background-color: black; /* This sets the color of the gaps */

    & > * {
        // border: none; /* Remove individual borders */
        width: 100%; /* Ensure items take full width within the grid */
    }

`;

const BlackLine = styled.div`
    background-color: black;
    width: 100%;
    height: 4px;
`;
const LastGrid = styled.div`
    height: 30vh;
    width: 50%;
    border: 4px solid black;
    border-top: none;
    border-bottom: none;
    margin-left: 25%;
`;

const Desktop30 = (props) => {
    let count = 1;
    let direction = 0; // 0 = right, 1 = left
    const items = props && props.thirty ? props.thirty : [];
    const allButLast = items.slice(0, -1);
    const lastItem = items[items.length - 1];
    console.log(allButLast)

    return (
        <>
            <PrimeGrid>
                <div className="M">-</div>
                <div className="P">-</div>
                <div className="R">3</div>
                <div className="I">0</div>
            </PrimeGrid>

            {/* 15 rows of containers, starting with left first */}
            <Container>
                <Grid>
                    {allButLast.map((allButLast, index) => {
                        if (count === 2) {
                            count = 1;
                            direction = !direction; //switch direction
                        } else {
                            count += 1; //continue for 1 more of this direction
                        }
                        return (
                            <ThirtyCard
                                article_title={allButLast.article_title}
                                article_url={allButLast.article_url}
                                article_byline={allButLast.article_byline}
                                article_image={allButLast.article_image}
                                position={direction ? "left" : "right"} //0 for right, 1 for left
                                color={allButLast.color}
                            />
                        );
                    })}
                </Grid>
                <BlackLine />
                    <LastGrid>
                            <ThirtyCard
                                article_title={lastItem.article_title}
                                article_url={lastItem.article_url}
                                article_byline={lastItem.article_byline}
                                article_image={lastItem.article_image}
                                position={direction ? "left" : "right"} //0 for right, 1 for left
                                color={lastItem.color}
                            />
                         </LastGrid>
                        <BlackLine />
            </Container>


            
        </>
    );
};

export default Desktop30;
